<template>
  <div class="list-widget">
    <div class="widget-header">
      <h3>{{ title }}</h3>
    </div>

    <div class="table-container">
      <table class="data-table">
        <thead>
          <tr>
            <th class="col-name">{{ tConfig(columns?.name, lang) }}</th>
            <th class="col-value">{{ tConfig(columns?.value, lang) }}</th>
            <th class="col-percent">{{ tConfig(columns?.percent, lang) }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in data" :key="index" :class="{ 'alt-row': index % 2 === 0 }">
            <td class="col-name">{{ item.comarca }}</td>
            <td class="col-value">{{ formatValue(item.counts) }}</td>
            <td class="col-percent">
              <div class="percent-wrapper">
                <div class="percent-bar" :style="{ width: item.percent + '%' }"></div>
                <span class="percent-text">{{ item.percent }}%</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
import { tConfig } from '../i18n/index.js';

defineProps({
  title: { type: String, default: '' },
  columns: { type: Object, default: () => ({}) },
  lang: { type: String, default: 'ca_es' },
  data: { type: Array, required: true }
});

function formatValue(val) {
  if (typeof val === 'number') {
    return val.toLocaleString('es-ES');
  }
  return val;
}
</script>

<style scoped>
.list-widget {
  background: white;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  height: 100%;
  box-sizing: border-box;
}

.widget-header h3 {
  font-size: 1.125rem;
  font-weight: 600;
  color: #111827;
  margin-top: 0;
  margin-bottom: 16px;
}

.table-container {
  flex: 1;
  overflow-y: auto;
  max-height: 500px;
  scrollbar-width: thin;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.875rem;
}

.data-table th {
  text-align: left;
  padding: 10px 8px;
  font-weight: 600;
  color: #374151;
  border-bottom: 2px solid #f3f4f6;
  background: white;
  position: sticky;
  top: 0;
  z-index: 5;
}

.data-table td {
  padding: 10px 8px;
  color: #4b5563;
  vertical-align: middle;
}

.alt-row {
  background-color: #f9fafb;
}

.col-name {
  width: 40%;
}

.col-value {
  width: 25%;
  text-align: right;
}

.col-percent {
  width: 35%;
}

.percent-wrapper {
  position: relative;
  width: 100%;
  height: 24px;
  background-color: #f3f4f6;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  align-items: center;
}

.percent-bar {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background-color: #0b5394;
  opacity: 0.9;
  transition: width 0.5s ease;
}

.percent-text {
  position: relative;
  z-index: 2;
  margin-left: 8px;
  font-weight: 500;
  color: #111827;
  font-size: 0.75rem;
}

tr:hover {
  background-color: #eff6ff;
}

.table-container::-webkit-scrollbar {
  width: 6px;
}

.table-container::-webkit-scrollbar-thumb {
  background-color: #d1d5db;
  border-radius: 3px;
}
</style>
